// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__8AEn3","links":"Navbar_links__UwC3W","sidebar":"Navbar_sidebar__NigCZ"};